module.exports = __webpack_public_path__ + "img/testimonial_5.27f3195a.png";